<template lang="pug">
    div
        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :addButtonText="addButtonText"
            :userCanCreate="true"
            :userCanIndex="true"
            :userCanDelete="true"
            :actionInTable="true"
            :userCanBatchEdit="true"
            :userCanBatchDelete="true"
            :userCanSearchByTag="true"
            :drawerTitleKey="drawerTitleKey"
            ref="rcmTable"
            :searchView="searchView"
            :sectionInfo="sectionInfo"
            primarySearchKey="servername"
            :primarySearchKeyI18="$t('domainsetting.servername')"
            :batchSelector="batchSelector"
            :givenBatchSearchFilters="givenBatchSearchFilters"
            :isCreateBtnDisabled="!$can('write', 'domainManagePermission','FQDNConfig')"
            :isEditBtnDisabled="!$can('write', 'domainManagePermission','FQDNConfig')"
            :isDeleteBtnDisabled="!$can('write', 'domainManagePermission','FQDNConfig')"
            :isBatchEditBtnDisabled="!$can('write', 'domainManagePermission','FQDNConfig')"
            :isBatchDeleteBtnDisabled="!$can('write', 'domainManagePermission','FQDNConfig')"
            :isImportCSV="true"
        )
            template(slot="tableUpperBtn")
                Button.left-under-table-btn(
                    :disabled="!$can('write', 'domainManagePermission','FQDNConfig')"
                    @click="isBatchClearCacheFormShown = true"
                ) {{$t('cacheClear.addBtnText')}}

        // batch清緩存
        Drawer(title="Batch Purge" v-model="isBatchClearCacheFormShown" width="70" :styles="formDrawerStyles")
            BatchClearCacheForm(
                :esIndex="esIndex"
                :batchSelector="batchSelector"
                v-if="isBatchClearCacheFormShown"
                @batchSubmitComplete="isBatchClearCacheFormShown = false"
                :batchSelectorWith="batchSelectorWith"
                :givenBatchSearchFilters="givenBatchSearchFilters"
                :batchClearCachePage="'domain'"
                )
        DependencyObjectModal(:isDependencyObjectAlertShown="isDependencyObjectAlertShown" :dependencyConfig="dependencyConfig" @closeDependencyObjectAlert="isDependencyObjectAlertShown = false")
</template>
<script>
import Vue from "vue";

import RcmTable from "@/components/RcmTable_v2";
import TagList from "@/components/TagList";
import bus from "@/libs/bus.js";
import BatchClearCacheForm from "@/components/BatchClearCacheForm";
import FQDNSelector from "@/components/FQDNSelector";

import CopyText from "@/components/CopyText";
import JsonPoptip from "@/components/JsonPoptip";
import ObjectLogBtn from "@/components/ObjectLogBtn";
import ExplainScheme from "@/components/PoptipInfos/ExplainScheme";
import ExplainURLRewrite from "@/components/PoptipInfos/ExplainURLRewrite";
import ExplainArgsRewrite from "@/components/PoptipInfos/ExplainArgsRewrite";
import checkCname from "@/components/checkCname";

import DependencyObjectModal from "@/components/DependencyObjectModal";
import ExplainCacheUrlRule from "@/components/PoptipInfos/ExplainCacheUrlRule";
import WildcardCSRPoptip from "@/components/FormItems/WildcardCSRPoptip.vue";
import DomainCertPoptip from "@/components/FormItems/DomainCertPoptip.vue";

import { getFormOptions } from "@/api/formoptions";

import {
    // settingZoneExplain,
    appProfileName,
    serviceGroupName,
    customHostHeader,
    httpPort,
    httpsPort,
    redirecthttps,
    useHttp2,
    useHsts,
    useSystemCert,
    keypairname,
    originPort,
    origins,
    originScheme,
    portMappingType,
    usedOriginPolicies,
    isEnforceProtectWithPaw,
    isEnforceProtectWithSwitch,
    description,
    action,
} from "./fields.js";

Vue.component("TagList", TagList);
Vue.component("CopyText", CopyText);
Vue.component("JsonPoptip", JsonPoptip);
Vue.component("ObjectLogBtn", ObjectLogBtn);
Vue.component("ExplainScheme", ExplainScheme);
Vue.component("checkCname", checkCname);
Vue.component("ExplainURLRewrite", ExplainURLRewrite);
Vue.component("ExplainArgsRewrite", ExplainArgsRewrite);
Vue.component("ExplainCacheUrlRule", ExplainCacheUrlRule);
Vue.component("WildcardCSRPoptip", WildcardCSRPoptip);
Vue.component("DomainCertPoptip", DomainCertPoptip);

export default {
    name: "DomainSetting",
    components: { RcmTable, TagList, BatchClearCacheForm, FQDNSelector, DependencyObjectModal },
    data() {
        return {
            batchSelector: "FQDNSelector",
            batchSelectorWith: ["groupName", "appProfileName", "servername"],
            givenBatchSearchFilters: [
                {
                    key: "groupName",
                    type: "string",
                    value: this.$store.state.queryGroupName,
                },
                {
                    key: "appProfileName",
                    type: "string",
                    value: `none`,
                },
            ],
            searchView: "DomainSetting",
            esIndex: "rcm-nginxconfigs",
            drawerTitleKey: "servername",
            isBatchClearCacheFormShown: false,
            formDrawerStyles: {
                height: "calc(100% - 120px)",
                overflow: "auto",
                paddingBottom: "53px",
                position: "static",
            },
            dependencyConfig: {
                objectKey: "servicegroupnames",
                queryKey: "serviceGroupNames",
                path: "/servicegroup",
                name: "servicegroup",
                hasPermission: this.$can("write", "groupResourcesPermission", "ServiceGroup"),
            },
            isDependencyObjectAlertShown: false,
        };
    },
    computed: {
        addButtonText() {
            return this.$i18n.t("domainsetting.createText");
        },
        sectionInfo() {
            let sectionInfo = [
                {
                    sectionKey: "cache",
                    sectionDescription:
                        "<p>Setup the cache behavior of path or file, the rule will take the order with <strong>Uncache > Cache</strong> </br>If omit the setting, we have the default cache extention of bmp, class, css, csv, doc, docx, ejs, eot, eps, gif, ico, jar, jpeg, jpg, js, mid, midi, otf, pdf, pict, pls, png, ppt, pptx, ps, svg, svgz, swf, tif, tiff, ttf, webp, woff, woff2, xls, xlsx.</p>",
                },
            ];
            return sectionInfo;
        },
        esIndexFields() {
            let esIndexFields = {};

            esIndexFields = this.$store.getters.isAdmin
                ? {
                      action: action(this),
                      createBy: {},
                      // settingZoneExplain: settingZoneExplain(this),
                      groupName: {},
                      servername: {},
                      _id: {},
                      appProfileName: appProfileName(this),
                      cnameHint: {},
                      serviceGroupName: serviceGroupName(this),
                      useOriginPolicy: {},
                      usedOriginPolicies: usedOriginPolicies(this),
                      origins: origins(this),
                      scheme: {},
                      httpPort: httpPort(this),
                      httpsPort: httpsPort(this),
                      redirecthttps: {},
                      redirectHttpCode: {},
                      useHttp2: useHttp2(this),
                      useHsts: useHsts(this),
                      hasSystemCert: {},
                      useSystemCert: useSystemCert(this),
                      sslProvider: {},
                      keypairname: keypairname(this),
                      isAllowOCSP: {},
                      usedWafRules: {},
                      isUsedWafRules: {},
                      isUseOwasp: { showInTable: false },
                      owaspRuleName: { showInTable: false },
                      tags: {},
                      description: description(this),
                      originscheme: originScheme(this),
                      portMappingType: portMappingType(this),
                      originPort: originPort(this),
                      setCustomHostHeader: {},
                      customHostHeader: customHostHeader(this),
                      errorHtmlPageName: {},
                      upstreamTimeout: {},
                      isEnabledCompressionToOrigin: {},
                      isEnabledUpstreamHttp11: {},
                      isInsertRidHeaderToOrigin: {},
                      isAcceptHttpV1: {},
                      websocketPath: {},
                      proxyBufferSize: {},
                      customVariables: {},
                      proxySetHeader: {},
                      isUpgradeInsecureRequest: {},
                      maxUploadSize: {},
                      rewriteUrlRules: {},
                      cacheUrlRules: {},
                      isEnforceProtect: this.$store.getters.getDomainConfig.isEnforceProtectWithPaw
                          ? isEnforceProtectWithPaw(this)
                          : isEnforceProtectWithSwitch(this),
                      proxyCacheIgnoreArgs: { showInTable: false },
                      cusCachepath: { showInTable: false },
                      cusCachefile: { showInTable: false },
                      forceCusCachePath: { showInTable: false },
                      forceCusCacheFile: { showInTable: false },
                      cusNoncachepath: { showInTable: false },
                      cusNonachefile: { showInTable: false },
                      cusFollowCachePath: { showInTable: false },
                      cusFollowCacheFile: { showInTable: false },
                      cusCachepathExp: {},
                      cusCachepathSrvexp: {},
                      cusCachefileExp: {},
                      cusCachefileSrvexp: {},
                      defCachefileExp: {},
                      defCachefileSrvexp: {},
                      defCachefile: {},
                      defNoncachepath: {},
                      currentCname: {},
                      cnameInfo: {},
                      createdDate: {},
                      modifiedDate: {},
                      status: {},
                      platformVersion: {},
                      objectLog: {},
                  }
                : {
                      action: action(this),
                      createBy: {},
                      // settingZoneExplain: settingZoneExplain(this),
                      groupName: {},
                      servername: {},
                      _id: {},
                      appProfileName: appProfileName(this),
                      //   cnameHint: {},
                      serviceGroupName: serviceGroupName(this),
                      origins: origins(this),
                      useOriginPolicy: {},
                      usedOriginPolicies: usedOriginPolicies(this),
                      scheme: {},
                      httpPort: httpPort(this),
                      httpsPort: httpsPort(this),
                      redirecthttps: {},
                      redirectHttpCode: {},
                      useHsts: useHsts(this),
                      hasSystemCert: {},
                      useSystemCert: useSystemCert(this),
                      sslProvider: {},
                      keypairname: keypairname(this),
                      isAllowOCSP: {},
                      usedWafRules: {},
                      isUsedWafRules: {},
                      isUseOwasp: { showInTable: false },
                      owaspRuleName: { showInTable: false },
                      tags: {},
                      description: description(this),
                      originscheme: originScheme(this),
                      portMappingType: portMappingType(this),
                      originPort: originPort(this),
                      setCustomHostHeader: {},
                      customHostHeader: customHostHeader(this),
                      errorHtmlPageName: {},
                      upstreamTimeout: {},
                      isEnabledCompressionToOrigin: {},
                      isEnabledUpstreamHttp11: {},
                      isInsertRidHeaderToOrigin: {},
                      isAcceptHttpV1: {},
                      websocketPath: {},
                      proxyBufferSize: {},
                      customVariables: {},
                      proxySetHeader: {},
                      isUpgradeInsecureRequest: {},
                      maxUploadSize: {},
                      rewriteUrlRules: {},
                      cacheUrlRules: {},
                      proxyCacheIgnoreArgs: { showInTable: false },
                      cusCachepath: { showInTable: false },
                      cusCachefile: { showInTable: false },
                      forceCusCachePath: { showInTable: false },
                      forceCusCacheFile: { showInTable: false },
                      cusNoncachepath: { showInTable: false },
                      cusNonachefile: { showInTable: false },
                      cusFollowCachePath: { showInTable: false },
                      cusFollowCacheFile: { showInTable: false },
                      cusCachepathExp: {},
                      cusCachepathSrvexp: {},
                      cusCachefileExp: {},
                      cusCachefileSrvexp: {},
                      defCachefileExp: {},
                      defCachefileSrvexp: {},
                      defCachefile: {},
                      defNoncachepath: {},
                      currentCname: {},
                      cnameInfo: {},
                      createdDate: {},
                      modifiedDate: {},
                      status: {},
                      platformVersion: {},
                      objectLog: {},
                  };

            if (!this.$store.state.platformPrefs.functions.domain.isCnameHintShown) {
                delete esIndexFields.cnameHint;
            }
            return esIndexFields;
        },
    },
    methods: {
        async checkObjectCanBeCreated() {
            let result = await getFormOptions(
                `/${this.dependencyConfig.objectKey}?groupName=${this.$store.state.queryGroupName}&${this.dependencyConfig.queryKey}=***`
            );
            this.isDependencyObjectAlertShown = result.data.options.length == 0;
        },
    },
    watch: {
        "$store.state.rcmTableIsInitComplete": function (newVal, oldVal) {
            if (this.$router.currentRoute.query.create && newVal) {
                this.$refs.rcmTable.manipulateItem("", "create");
            }
        },
    },
    mounted() {},
    created() {
        this.checkObjectCanBeCreated();
        this.$bus = bus;
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent, args) => {
            // 如果是找我的事件就接收處理, 否則向下傳遞
            switch (busEvent) {
                case "":
                    break;
                default:
                    bus.$emit(busEvent);
                    break;
            }
        });
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    },
};
</script>



// WEBPACK FOOTER //
// src/view/NoneProfileDomainSetting/Page.vue